<div class="modal-container" *ngIf="isVisible">
    <div class="modal-content">
        <div class="modal-header">
            <h2>{{ title }}</h2>
            <p class="modal-description" *ngIf="description" [innerHTML]="description"></p>
        </div>
        <div class="modal-body">
            <ng-content select="[modal-body]"></ng-content>
        </div>
        <div class="modal-footer">
            <ng-content select="[modal-footer]"></ng-content>
        </div>
    </div>
</div>